import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  getFetchOptions,
  convertIntoSelect2Options,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const DetailTeacher = () => {
  const [provsOption, setProvsOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [teacherSchoolsOptions, setTeacherSchoolsOptions] = useState([]);
  const [selectedTeacherSchool, setSelectedTeacherSchool] = useState("");
  const [teacherSchoolClasses, setTeacherSchoolClasses] = useState([]);
  const [teacherSubjects, setTeacherSubjects] = useState([]);
  const [teacherData, setTeacherData] = useState({});

  const currentMonth = new Date().getMonth();
  const schoolYear =
    currentMonth >= 8
      ? `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
      : `${new Date().getFullYear() - 1}${new Date().getFullYear()}`;

  const breadcrumb = {
    current_section: "Dettaglio",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Gestione insegnante", route_name: null, params: [] },
      { name: "Dettaglio", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();
        setProvsOption(result.provincie);
      } catch (error) {
        console.error(error);
      }
    };
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );
        const result = await response.json();
        setSchoolOptions(result.return.scuola);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchTeachers = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/user?id=${window.location.pathname
            .split("/")
            .pop()}`,
          fetchOptions
        );
        const result = await response.json();
        setTeacherData(result.return.user);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchTeachersSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getTeacherSchools?userId=${window.location.pathname
            .split("/")
            .pop()}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          console.error(result.error);
          setTeacherSchoolsOptions([]);
          return;
        }
        setTeacherSchoolsOptions(
          convertIntoSelect2Options(result, "id", "denomistituto")
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchProvs();
    fetchSchools();
    fetchTeachers();
    fetchTeachersSchools();
  }, []);

  useEffect(() => {
    handleImportProvinceChange(teacherData.idprovincia);
  }, [teacherData.idprovincia]);

  const handleSelectedTeacherSchool = async (id) => {
    setSelectedTeacherSchool(id);

    if (!id) {
      setTeacherSchoolClasses([]);
      setTeacherSubjects([]);
      return;
    }

    const fetchTeacherClasses = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getTeacherClasses?userId=${window.location.pathname
            .split("/")
            .pop()}&schoolId=${id}&schoolYear=${schoolYear}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          console.error(result.error);
          setTeacherSchoolClasses([]);
          return;
        }
        setTeacherSchoolClasses(result);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchTeacherSubjects = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getTeacherSubjects?userId=${window.location.pathname
            .split("/")
            .pop()}&schoolId=${id}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          console.error(result.error);
          setTeacherSubjects([]);
          return;
        }
        setTeacherSubjects(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchTeacherClasses();
    fetchTeacherSubjects();
  };

  const handleImportProvinceChange = (id) => {
    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${id}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOption(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };

    fetchCities();
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a href="/teachers">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista insegnanti
        </button>
      </a>

      {/* Profile Image Upload */}
      <div className="card custom-card">
        <div className="card-header">Immagine del profilo</div>
        <div className="card-body">
          <div className="row row-cols-1 row-cols-lg-2 align-items-center">
            {teacherData.tokenimg && (
              <span
                className="avatar mx-3 mb-3 mb-lg-0"
                style={{ backgroundImage: `url(${teacherData.tokenimg})` }}
              ></span>
            )}
          </div>
        </div>
      </div>

      {/* General Data */}
      <div className="card custom-card">
        <div className="card-header card-title">
          <span>Dettaglio</span>
        </div>
        <div className="card-body">
          <form id="teacherForm">
            <div className="row mb-5">
              <div className="col-12 col-lg-4">
                <label htmlFor="school">Scuola Principale</label>
                <select
                  label="Scegli Scuola"
                  id="school"
                  name="school"
                  value={teacherData.idscuola || 0}
                  className="form-control"
                  required
                  disabled
                >
                  <option value={0} disabled>
                    Scegli scuola...
                  </option>
                  {schoolOptions.map((school) => (
                    <option key={school.id} value={school.id}>
                      {school.denomistituto}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-12 col-lg-4">
                <label htmlFor="province">Provincia</label>
                <select
                  label="Scegli Provincia"
                  id="province"
                  name="province"
                  value={teacherData.idprovincia || 0}
                  disabled
                  className="form-control"
                >
                  <option value={0} disabled>
                    Scegli provincia...
                  </option>
                  {provsOption.map((prov) => (
                    <option key={prov.id} value={prov.id}>
                      {prov.nome + " (" + prov.codice + ")"}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="city">Comune</label>
                <select
                  id="city"
                  name="city"
                  value={teacherData.idcomune || 0}
                  disabled
                  className="form-control"
                >
                  <option value={0} disabled>
                    Scegli comune...
                  </option>
                  {cityOption &&
                    cityOption.map((city) => (
                      <option key={city.value} value={city.value}>
                        {city.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-12 col-lg-4">
                <label htmlFor="nominativo">Nominativo</label>
                <input
                  className="form-control"
                  id="nominativo"
                  name="nominativo"
                  label="nominativo"
                  value={teacherData.nominativo || ""}
                  disabled
                  required
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="telefono">Telefono</label>
                <input
                  className="form-control"
                  id="telefono"
                  name="telefono"
                  label="telefono"
                  value={teacherData.telefono || ""}
                  disabled
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="codicefiscale">Codice Fiscale</label>
                <input
                  className="form-control"
                  id="codicefiscale"
                  name="codicefiscale"
                  label="codicefiscale"
                  value={teacherData.cf || ""}
                  disabled
                />
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-12 col-lg-4">
                <label htmlFor="schoolYear">Anno scolastico</label>
                <select
                  className="form-control"
                  id="annoscolastico"
                  name="annoscolastico"
                  value={teacherData.annoscolastico || 0}
                  disabled
                >
                  <option value="">Scegli anno scolastico...</option>
                  {Array.from({ length: 10 }).map((_, idx) => {
                    const year = new Date().getFullYear() - 5 + idx;
                    const option = (
                      <option key={year} value={`${year}${year + 1}`}>
                        {`${year}/${year + 1}`}
                      </option>
                    );
                    return option;
                  })}
                </select>
              </div>
              <div className="col-12 col-lg-4">
                <label htmlFor="email">Email</label>
                <input
                  className="form-control"
                  type="email"
                  id="email"
                  name="email"
                  label="email"
                  value={teacherData.email || ""}
                  disabled
                  required
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Modular Data */}
      <div className="card custom-card">
        <div className="card-header card-title">
          <span>Dati correlati</span>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col">
              <label htmlFor="school">Scuola</label>
              <Select
                id="school"
                name="school"
                value={teacherSchoolsOptions?.filter(function (option) {
                  return option.value === selectedTeacherSchool;
                })}
                onChange={(e) => handleSelectedTeacherSchool(e?.value)}
                options={teacherSchoolsOptions}
                classNames={"form-control"}
                placeholder="Scegli scuola..."
                isSearchable
                isClearable
                isDisabled={teacherSchoolsOptions.length === 0}
                className="mb-3"
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="class">Classi</label>
              <div className="tableContainer mt-3">
                <table className="classesTable table table-bordered">
                  <thead>
                    <tr>
                      <th>Classe</th>
                      <th>Sezione</th>
                      <th>Materia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {teacherSchoolClasses?.map((classes) => (
                      <tr key={classes.idclasse}>
                        <td>{classes.Class.classe}</td>
                        <td>{classes.Class.sezione}</td>
                        <td>{classes.Subject.materia}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailTeacher;
